$bog_blitz_lobby_game_reactboard $mol_view
	players_dict null
	sub /
		<= Table_heart $mol_view
			sub /
				<= Title_heart $mol_paragraph
					title \❤️
				<= List_heart $mol_list
					rows <= rows_heart /
		<= Table_smile $mol_view
			sub /
				<= Title_smile $mol_paragraph
					title \😊
				<= List_smile $mol_list
					rows <= rows_smile /
		<= Table_fire $mol_view
			sub /
				<= Title_fire $mol_paragraph
					title \🔥
				<= List_fire $mol_list
					rows <= rows_fire /
		<= Table_clap $mol_view
			sub /
				<= Title_clap $mol_paragraph
					title \👏
				<= List_clap $mol_list
					rows <= rows_clap /
		<= Table_poop $mol_view
			sub /
				<= Title_poop $mol_paragraph
					title \💩
				<= List_poop $mol_list
					rows <= rows_poop /
	Row*0 $mol_view
		sub /
			<= Row_name* $mol_paragraph
				title <= row_name* \
			<= Row_count* $mol_paragraph
				title <= row_count* \
